<template>
    <div class="dynamicMarket width-full" v-bind:class="{ live: market.isLive }">
        <strong class="dynamicMarket_title">{{ market.name }}</strong>
        <div
            v-for="(row, rowIdx) in selectionRows"
            v-bind:key="rowIdx"
            class="dynamicMarket_row"
        >
            <template v-for="(cell, cellIdx) in row" v-bind:key="cellIdx">
                <DynamicMarketSelection
                    v-if="cell"
                    v-bind:selection="cell"
                    v-bind:market="market"
                    v-bind:isActive="currentBetSlip?.selectionId === cell.id"
                    v-on:click="onSelectionClick(cell)"
                />
                <div
                    v-else
                    class="dynamicMarket_cell"
                />
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import chunk from 'lodash/chunk';
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import DynamicMarketSelection from '@/components/oddsDisplay/moreMarket/marketType/DynamicMarketSelection.vue';
    import { padRight } from '@/core/lib/array';
    import type { IEvent } from '@/interface/IEvent';
    import type { IMarket, IMarketSelection } from '@/interface/IMarket';
    import { AsiaBetPageType, TabName } from '@/interface/enum';
    import { useBetSlipStore } from '@/store/betSlipStore';
    import { useLayoutStore } from '@/store/layoutStore';

    const props = defineProps<{
        event: IEvent;
        market: IMarket;
    }>();

    const { addToDynamicMarketBetSlip, removeDynamicMarketBetSlip } = useBetSlipStore();
    const { dynamicMarketBetSlip: currentBetSlip } = storeToRefs(useBetSlipStore());

    const { isLayoutExpanded } = storeToRefs(useLayoutStore());
    const { toggleIsSportListExpanded, toggleBetSlipExpanded, toggleMyBetsExpanded, setBetSlipActiveTab } = useLayoutStore();

    const selectionRows = computed(() => chunk(props.market.selections, 3).map(row => padRight(row, 3, null)));

    const betPage = AsiaBetPageType.DynamicMarket;

    const onSelectionClick = (selection: IMarketSelection) => {
        if (currentBetSlip.value?.selectionId === selection.id) {
            removeDynamicMarketBetSlip();
            return;
        }

        addToDynamicMarketBetSlip(props.event, props.market, selection, betPage);
        setBetSlipActiveTab(TabName.Single);
        toggleIsSportListExpanded(false);
        toggleBetSlipExpanded(true);
        if (!isLayoutExpanded.value) toggleMyBetsExpanded(false);
    };
</script>

<style lang="scss" scoped>
    @import "@/components/oddsDisplay/moreMarket/marketType/DynamicMarket";
</style>
